module.exports = __webpack_public_path__ + "img/TOP42022.2b327be7.png";